var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIcPlayerPlayFilled(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.434 11.022L6.767 4.163a1.19 1.19 0 00-1.174-.015A1.14 1.14 0 005 5.143v13.715c0 .412.226.792.591.995a1.19 1.19 0 001.176-.015l11.667-6.856c.351-.207.566-.578.566-.98s-.215-.773-.566-.98",
    fill: "#231815",
    fillRule: "evenodd"
  })));
}

export default "data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='24' height='24' viewBox='0 0 24 24'%3E %3Cg fill='none' fill-rule='evenodd'%3E %3Cg fill='%23231815'%3E %3Cpath d='M18.434 11.022L6.767 4.163c-.36-.211-.808-.217-1.174-.015-.367.204-.593.583-.593.995v13.715c0 .412.226.792.591.995.18.099.377.148.576.148.207 0 .416-.054.6-.163l11.667-6.856c.351-.207.566-.578.566-.98s-.215-.773-.566-.98'/%3E %3C/g%3E %3C/g%3E %3C/svg%3E";
export { SvgIcPlayerPlayFilled as ReactComponent };